import store from '../store';

export default function (to, from, next) {
	const user = store.state.user.user;
	const source = store.state.user.source;

	if (user) {

		if (source === 'cognito') {
			next();
		} else {
			store
				.dispatch('CHANGE_LOADING_STATE', true)
				.then(() => store
					.dispatch('user/RETRIEVE_USER_DATA')
					.then(() => next())
					.catch(() => next({name: 'login'}))
				);
		}

	} else {
		if (from.name === 'login') {
			store.dispatch('CHANGE_LOADING_STATE', false);
		}
		next({name: 'login'});
	}
}